import { type FunctionComponent } from 'react';

import OmniSignDocumentsContent from './Content';
import OmniSignDocumentsProvider from './context';

const OmniSignDocuments: FunctionComponent = () => (
  <OmniSignDocumentsProvider>
    <OmniSignDocumentsContent />
  </OmniSignDocumentsProvider>
);

export default OmniSignDocuments;
